import fetch from "../auth/FetchInterceptor";

const JwtAuthService = {
  login: function (data: any) {
    return fetch({
      url: "/sessions",
      method: "post",
      headers: {
        "public-request": "true",
      },
      data: data,
    });
  },
  signUp: function (data: any) {
    return fetch({
      url: "/users",
      method: "post",
      headers: {
        "public-request": "true",
      },
      data: data,
    });
  },
  signOut: function () {
    return fetch({
      url: "/auth/logout",
      method: "post",
    });
  },
};

export default JwtAuthService;
